<template>
    <div v-if="!modoVisualizacao">
        <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
        <MensagemAlerta class=" row-space" v-if="msgAlerta" :mensagem="msgAlerta" />

        <div class="form-edit-page row-space">
            <div class="row-start">
                <div class="form-item-rangedata"><RangeDataSelect :periodoInicial="'currentYear'" v-model="dateRange" /></div>
                <button type="button" class="buttom-icon--search" @click="lerDados" />
                <button type="button" class="buttom-icon--close" @click="closeForm" />
            </div>
        </div>

        
        <div v-if="lsDados.length>0" class="table-wrapper">
            <table>
                <thead><tr>
                    <th class="col-width-char20">Tipo Coleta</th>
                    <th class="col-width-data">Data</th>
                    <th class="col-width-char20">Protocolo</th>
                    <th class="col-width-char30">Nome Oficial</th>
                    <th>Nome Coletor</th>
                </tr></thead>
                <tbody>
                    <tr v-for="(obj, index) in lsDados" :key="obj.id" :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0, 'clickabe-row': true}"
                    @click="visualizarRegistro(obj)">
                        <td class="col-width-char20">{{ obj.xamostra_categoria }}</td>
                        <td class="col-width-data center">{{ formatDateFromJson(obj.amostra_dtcolheita) }}</td>
                        <td class="col-width-char20 center">{{ obj.xsequencia }}</td>
                        <td class="col-width-char30">{{ obj.amostra_nmoficial }}</td>
                        <td>{{ obj.nmcoletor }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        

        <div v-if="showPagination" class="pagination">
            <button :disabled="currentPage === 1" class="buttom-pagination--first" @click="currentPage=1; updatePaginatedData();" />
            <button :disabled="currentPage === 1" class="buttom-pagination--prior" @click="currentPage--; updatePaginatedData();" />
            <div class="field-label field-label-center">{{ currentPage }} de {{ Math.ceil(lsDadosMain.length / itemsPerPage) }}</div>
            <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--next" @click="currentPage++; updatePaginatedData();" />
            <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--last" @click="currentPage = Math.ceil(lsDadosMain.length / itemsPerPage); updatePaginatedData();" />
        </div>
    </div>

    <div v-if="modoVisualizacao">
        <Pla01ViewPage :idView="idView" @close="modoVisualizacao = false" />
    </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { genericPost } from '@/funcoes/api';
import { globalStore } from '@/globals';
import { formatDateFromJson, validarIntervaloDatas } from '@/funcoes/utils';
import MensagemAlerta from '@/components/utils/MensagemAlerta.vue';
import Pla01ViewPage from '../visualizacoes/Pla01ViewPage.vue';
import RangeDataSelect from '@/components/selects/RangeDataSelect.vue';

const emit = defineEmits(['close']);
const dateRange = ref({ startDate: "", endDate: "", selectedPeriod: "" });
const msgAlerta = ref(null);
const idView = ref(0);
const isLoading = ref(false);
const lsDados = ref([]);
const lsDadosMain = ref([]);
const modoVisualizacao = ref(false);

const currentPage = ref(1);
const itemsPerPage = ref(globalStore.itensPorPagina);
const showPagination = ref(false);

const closeForm = () => {emit('close');}

const lerDados = async() => {
    try {
        const x = validarIntervaloDatas(dateRange.value.startDate, dateRange.value.endDate);
        if (x) throw new Error(x);
        msgAlerta.value = null;
        isLoading.value = true;
        const dados = {
            idep: globalStore.idep,
            idsim: globalStore.idsim,
            idestabelecimento: globalStore.idestabelecimento,
            datainicial: dateRange.value.startDate,
            datafinal: dateRange.value.endDate
        };
        const req = await genericPost('/lspla/pla01', dados);
        lsDadosMain.value = req;
        currentPage.value=1;
        showPagination.value = (lsDadosMain.value.length > itemsPerPage.value);
        updatePaginatedData();
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    } finally {isLoading.value = false;}
};

const updatePaginatedData = () => {
    const startIndex = (currentPage.value - 1) * itemsPerPage.value;
    const endIndex = (startIndex + itemsPerPage.value);
    lsDados.value = lsDadosMain.value.slice(startIndex, endIndex);
}

const visualizarRegistro = (obj) =>{
    idView.value = obj.id;
    modoVisualizacao.value = true;
}

onMounted(lerDados);
</script>